// extracted by mini-css-extract-plugin
module.exports = {"imgA":"imgA_imgA__zFpxg"};